import { render, staticRenderFns } from "./add-clasiification-dialog.vue?vue&type=template&id=4fc4b8c7&scoped=true&"
import script from "./add-clasiification-dialog.vue?vue&type=script&lang=js&"
export * from "./add-clasiification-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-clasiification-dialog.vue?vue&type=style&index=0&id=4fc4b8c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4b8c7",
  null
  
)

export default component.exports